/**
 * Helpers for the transient `preview_space` query param.
 *
 * When the shell event composer is open and the user clicks a space on the
 * office map, we don't add the space directly. Instead we *background* the
 * composer (keep it mounted but collapsed) and foreground the office
 * space-details sider so the user can review the space and choose "Add to
 * event". `preview_space` is the cross-app signal that coordinates this: its
 * presence means "composer is backgrounded; the office is previewing a space".
 *
 * The value is the previewed space id — self-describing and read straight from
 * the URL, so it's reliable even when the office's `csr` (currently selected
 * resource) atom is momentarily cleared as recoil-sync re-reads the URL (the
 * same rationale as the create-composer `space_id` seed).
 *
 * Shell and each MFE mount their own router, so writers must cross the boundary
 * with `replaceSharedUrl` (synthetic popstate) — the same pattern used for the
 * `event` param.
 */
export var COMPOSER_SPACE_PREVIEW_PARAM = 'preview_space';
/**
 * Read the previewed space id from a location search string (e.g.
 * `useLocation().search`). Returns `null` when the param is absent or empty.
 */
export var getComposerSpacePreviewId = function (search) {
    var value = new URLSearchParams(search).get(COMPOSER_SPACE_PREVIEW_PARAM);
    return value === null || value === '' ? null : value;
};
